import { BaseController } from '../../../../common/base/controller';

export class StandingOrderFormController extends BaseController {
  constructor(
    controllerService,
    inputFormService,
    standingOrderFormFields,
    dataParser,
    clipboard,
    $scope,
    $compile,
  ) {
    'ngInject';
    super({
      controllerService,
      inputFormService,
      standingOrderFormFields,
      dataParser,
      clipboard,
      $scope,
      $compile,
    });
  }

  $onInit() {
    if (this.copyToClipboard) {
      this.clipboardTooltips = {};
    }

    // Initialize fields when language options has been loaded
    this.setLanguageOptions().then(() => this.setupFields());
    this.bindEvents();
  }

  setupFields() {
    this.fields = this.inputFormService.getFields(
      this.formDefinition || this.standingOrderFormFields(this.category),
      this.languageOptions,
      this.model,
    );
  }

  bindEvents() {
    const { $scope } = this;
    $scope.$on('standingOrders.setupFields', () => this.setupFields());
  }

  onSelect($event) {
    // Copy selected value to clipboard
    if (this.copyToClipboard) {
      this.clipboard.copyText($event.target.value);
      this.clipboardTooltips[$event.target.name] = true;
    }
    $event.target.select();
  }
}
